import { render, staticRenderFns } from "./SearchResultView.vue?vue&type=template&id=16b775bc&"
import script from "./SearchResultView.vue?vue&type=script&lang=js&"
export * from "./SearchResultView.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports